const IconCategory = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960" 
            fill={color}
        >
            <path d="m260-520 220-360 220 360H260ZM700-80q-75 0-127.5-52.5T520-260q0-75 52.5-127.5T700-440q75 0 127.5 52.5T880-260q0 75-52.5 127.5T700-80Zm-580-20v-320h320v320H120Zm580-60q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-500-20h160v-160H200v160Zm202-420h156l-78-126-78 126Zm78 0ZM360-340Zm340 80Z"/>
        </svg>
    )
}

export default IconCategory; 